//@ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

type Props = {
  open: boolean;
  setIsOpen: (value: boolean) => void;
};

export const CargoPrinterDialog = (props: Props) => {
  var selected_device;
  var devices = [];
  const [values, setValues] = useState({
    client: "",
    order: "",
    cargo: "",
    address: "",
  });

  function writeToSelectedPrinter(dataToWrite) {
    selected_device.send(dataToWrite, undefined, errorCallback);
  }

  var errorCallback = function (errorMessage) {
    alert("Error: " + errorMessage);
  };

  function onDeviceSelected(selected) {
    for (var i = 0; i < devices.length; ++i) {
      if (selected.value == devices[i].uid) {
        selected_device = devices[i];
        return;
      }
    }
  }
  useEffect(() => {
    function setup() {
      //Get the default device from the application as a first step. Discovery takes longer to complete.
      BrowserPrint.getDefaultDevice(
        "printer",
        function (device) {
          //Add device to list of devices and to html select element
          selected_device = device;
          devices.push(device);
          var html_select = document.getElementById("selected_device");
          var option = document.createElement("option");
          option.text = device.name;
          html_select.add(option);

          //Discover any other devices available to the application
          BrowserPrint.getLocalDevices(
            function (device_list) {
              for (var i = 0; i < device_list.length; i++) {
                //Add device to list of devices and to html select element
                var device = device_list[i];
                if (!selected_device || device.uid != selected_device.uid) {
                  devices.push(device);
                  var option = document.createElement("option");
                  option.text = device.name;
                  option.value = device.uid;
                  html_select.add(option);
                }
              }
            },
            function () {
              alert("Error getting local devices");
            },
            "printer"
          );
        },
        function (error) {
          alert(error);
        }
      );
    }
    setup();
  }, [props.open]);

  return (
    <Dialog open={props.open} onClose={() => props.setIsOpen(false)}>
      <DialogContent>
        <div>
          <Typography variant="h6">Imprimir Etiqueta</Typography>
          Aparelho selecionado:
          <select
            id="selected_device"
            onChange={() => onDeviceSelected(this)}
          ></select>
          <br />
          <br />
          <Stack direction="column" spacing={3}>
            <TextField
              label="Cliente"
              value={values.client}
              onChange={(e) => {
                setValues((old) => ({ ...old, client: e.target.value }));
              }}
            />
            <TextField
              label="Pedido"
              value={values.order}
              onChange={(e) => {
                setValues((old) => ({ ...old, order: e.target.value }));
              }}
            />
            <TextField
              label="Carga"
              value={values.cargo}
              onChange={(e) => {
                setValues((old) => ({ ...old, cargo: e.target.value }));
              }}
            />
            <TextField
              label="Endereço de Entrega"
              value={values.address}
              onChange={(e) => {
                setValues((old) => ({ ...old, address: e.target.value }));
              }}
            />
          </Stack>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setIsOpen(false)}>Cancelar</Button>
        <Button
          variant="contained"
          type="button"
          value="Send ZPL Label"
          onClick={() => {
            const addressArray = [];

            for (let i = 0; i < values.address.length; i += 27) {
              const chunk = values.address.substring(i, i + 27);
              addressArray.push(chunk);
            }

            const zpl = `
  ^XA

  ^FX Top section with logo, name and address.
  ^CF0,60
  ^FO140,50^FDElimacol Acabamentos^FS
  ^CF0,30
  ^FO50,170^GB700,3,3^FS
  
  ^FX Second section with recipient address and permit information.
  ^CFA,30
  ^FO50,200^FDCliente^FS
  ^CF0,40
  ^FO50,250^FD${
    values.client.lenght <= 54 ? values.client : values.client.substring(0, 54)
  }^FS
  ^CFA,30
  ^FO50,310^FDPedido^FS
  ^CF0,40
  ^FO50,360^FD${values.order}^FS
  ^CFA,30
  ^FO50,410^FDCarga^FS
  ^CF0,40
  ^FO50,460^FD${values.cargo}^FS
  
  ^CFA,15
  
  ^FO50,520^GB700,3,3^FS
  
  ^FX Fourth section (the two boxes on the bottom).
  ^FO50,550^GB700,400,3^FS
  ^CF0,50
  ${addressArray.map((string, index) => {
    if (index > 4) return;
    return "^FO100," + (610 + index * 70) + "^FD" + string + "^FS";
  })}
  
  ^CFA,30
  ${
    false &&
    `^FO50,990^FDConferido por^FS
  ^FO300,990^FDWagner^FS
  ^FO50,1040^FDEm^FS
  ^FO300,1040^FD12/08/2024^FS`
  }
  
  ^XZ
  `;

            writeToSelectedPrinter(zpl);
          }}
        >
          Imprimir
        </Button>
      </DialogActions>
    </Dialog>
  );
};
